import React from "react";
import Header from "../../component/header/header";
import Footer from "../../component/footer/footer";
import { Container, Row, Col, Card, Button } from "react-bootstrap";
import { motion } from "framer-motion";
import "./blog.css";

const fadeUp = {
  hidden: { opacity: 0, y: 60 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.7 } },
};

const Blog = () => {
  return (
    <div className="blog-page" style={{ backgroundColor: "#f9f9f9" }}>
      {/* Header */}
      <Header />

      {/* =================== HERO SECTION ===================== */}
      <section>
        <div className="blog-hero-section mb-5">
          <h1>Blog Page</h1>
        </div>

        <div style={{ textAlign: "center" }}>
          <motion.h1
            initial={{ opacity: 0, y: -50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            style={{ fontSize: "45px", fontWeight: "bold" }}
          >
            Business Startup Blogs
          </motion.h1>

          <motion.p
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.4 }}
            style={{ fontSize: "18px", maxWidth: "700px", margin: "20px auto" }}
          >
            Explore powerful articles to help you grow your startup, learn
            business strategies, and achieve success faster.
          </motion.p>
        </div>
      </section>

      {/* =================== LATEST BLOGS ===================== */}
      <Container style={{ padding: "70px 0" }}>
        <motion.h2
          variants={fadeUp}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          style={{
            textAlign: "center",
            marginBottom: "50px",
            fontWeight: "bold",
          }}
        >
          Latest Blogs
        </motion.h2>

        <Row>
          {[1, 2, 3].map((blog) => (
            <Col lg={4} md={6} sm={12} key={blog} className="mb-4">
              <motion.div
                variants={fadeUp}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true }}
              >
                <Card style={{ borderRadius: "15px", overflow: "hidden" }}>
                  <Card.Img
                    variant="top"
                    src={"./images/in-1.jpg"}
                  />
                  <Card.Body>
                    <Card.Title>How to Grow Your Startup in 2025</Card.Title>
                    <Card.Text>
                      Learn the best strategies to scale your startup, create a
                      strong brand, and build a winning team.
                    </Card.Text>
                    <Button variant="dark">Read More</Button>
                  </Card.Body>
                </Card>
              </motion.div>
            </Col>
          ))}
        </Row>
      </Container>

      {/* =================== BUSINESS TIPS SECTION ===================== */}
      <section
        style={{
          padding: "70px 20px",
          backgroundColor: "#fff",
        }}
      >
        <Container>
          <Row className="align-items-center">
            <Col md={6}>
              <motion.img
                src="./images/in-2.jpg"
                alt="business tips"
                style={{ width: "100%", borderRadius: "15px" }}
                initial={{ opacity: 0, x: -80 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.8 }}
                viewport={{ once: true }}
              />
            </Col>

            <Col md={6}>
              <motion.h2
                initial={{ opacity: 0, x: 80 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.8 }}
                viewport={{ once: true }}
              >
                Smart Tips for New Entrepreneurs
              </motion.h2>

              <motion.ul
                initial={{ opacity: 0, x: 80 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ delay: 0.3 }}
                viewport={{ once: true }}
                style={{ fontSize: "18px", lineHeight: "32px" }}
              >
                <li>Build a strong online presence</li>
                <li>Focus on customer experience</li>
                <li>Create a scalable business model</li>
                <li>Invest in marketing early</li>
                <li>Learn from competitors</li>
              </motion.ul>
            </Col>
          </Row>
        </Container>
      </section>

      {/* =================== SUBSCRIBE NEWSLETTER ===================== */}
      <section
        style={{
          padding: "60px 20px",
          background: "linear-gradient(135deg, #000, #ffb6c1)",
          color: "#fff",
          textAlign: "center",
        }}
      >
        <motion.h2
          initial={{ opacity: 0, scale: 0.7 }}
          whileInView={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.6 }}
        >
          Subscribe for Startup Insights
        </motion.h2>

        <motion.p
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ delay: 0.3 }}
        >
          Get weekly business tips and startup hacks directly into your inbox.
        </motion.p>

        <motion.input
          type="email"
          placeholder="Enter your email"
          style={{
            padding: "12px",
            width: "300px",
            borderRadius: "8px",
            border: "none",
            marginTop: "20px",
          }}
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7 }}
        />

        <br />

        <motion.button
          className="btn btn-light mt-3"
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.3 }}
        >
          Subscribe Now
        </motion.button>
      </section>

      {/* Footer */}
      <Footer />
    </div>
  );
};

export default Blog;
